import{a as e}from"./chunk-QEKOZYJ5.js";import{a as r}from"./chunk-RAAYCPUM.js";function t(...n){return r(e,n)}export{t as a};
